<template>
	<div class="nav-box">
		<div class="tab border-1px">
			<div class="tab-item">
				<router-link to="/home">首页</router-link>
			</div>
			<div class="tab-item">
				<router-link to="/IntelligentDevice">智能设备</router-link>
			</div>
			<div class="tab-item">
				<router-link to="/TechnologySystem">技术体系</router-link>
			</div>
			<div class="tab-item">
				<router-link to="/CustomerCase">客户案例</router-link>
			</div>
			<div class="tab-item">
				<router-link to="/TechnicalSupport">技术支持</router-link>
			</div>
      <!-- <div class="tab-item">
      	<router-link to="/ResourceInfo">资源信息</router-link>
      </div> -->
		</div>
	</div>
</template>

<script>
	export default{

	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import url("../../assets/css/animate.min.css");
	.tab
		display: flex
		width: 100%
		/*border-1px(rgba(7, 17, 27, 0.1))*/
		.tab-item
			flex: 1
			text-align: center
			&>a
				display: inline-block
				width: 100%
				height: 60px
				line-height: 60px
				font-size: 18px
				color: #061f3e
				&.active, &:hover
					color: #fff
					background: #ff6600
					font-weight: bold

</style>



// WEBPACK FOOTER //
// src/components/common/nav.vue